export default __webpack_public_path__ + "static/media/bg.312bae46.svg";